import { render, staticRenderFns } from "./iconOnlyCredit.vue?vue&type=template&id=256f502f&scoped=true"
import script from "./iconOnlyCredit.vue?vue&type=script&lang=js"
export * from "./iconOnlyCredit.vue?vue&type=script&lang=js"
import style0 from "./iconOnlyCredit.vue?vue&type=style&index=0&id=256f502f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256f502f",
  null
  
)

export default component.exports